export const Summary = {
  PlanNameText: 'plan-name-text',
  PlanPriceText: 'plan-price-text',
  AddonNameTextPrefix: 'addon-text',
  TotalPriceText: 'total-price-text',
  NextBtn: 'next-btn',
  BackBtn: 'back-btn',
  CompareBtn: 'compare-btn',
} as const;
